import { InputField, Label, PrimaryButton, SwitchToggle } from "client/CommonComponents";
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import './Addfilter.scss'
import ExistingList from "../ExistingList";
import { AttributeName, CONSTANTS } from "client/utils/constants";
import permissions, { isAuthorized } from "client/utils/Permissions";

const AddFilter = (props: any) => {
    const {
        ExistingDropDownValue,
        filterName,
        handleOnChange,
        fieldValue,
        onClickAdd,
        removeItem,
        fieldValueError,
        hideDialogComplete,
        PopupcontentComplete,
        onToggleChange,
        isShowVehicleCapacityChecked,
        catalogItemValues
    } = props

    return (
        <div className="add-vehicle-level-block vehicle">
            <div className="asset-type-btn-block mb-2">
                <Label required data-attribute="AddFilter_Default_Label">{filterName == AttributeName.VEHICLE_LEVEL ? AttributeName.ASSIGNMENT_GROUPS : filterName}</Label>
                <div className="popup_block">
                    <InputField
                        placeholder={`Enter ${filterName == AttributeName.VEHICLE_LEVEL ? AttributeName.ASSIGNMENT_GROUPS : filterName}`}
                        value={fieldValue}
                        onChange={(e: any) => handleOnChange(e, filterName)}
                        className={`inputfieldwidth ${fieldValueError?.length ? "controlValidation" : ''}`}
                     data-attribute="AddFilter_Default_Input" />

                    <PrimaryButton
                        text='Add'
                        className='pull-right add-vehicle-level ms-3'
                        onClick={onClickAdd} 
                        disabled={!isAuthorized(permissions?.CreateEditCatalog)}
                     data-attribute="AddFilter_Default_Button" />
                </div>
            </div>
            {fieldValueError ? <p className='validMessage'>{fieldValueError}</p> : ""}
            {(filterName == AttributeName.CLASS_TYPE && catalogItemValues?.vehicleType?.label == CONSTANTS.PRODUCTION_VEHICLE) ?
                <div>
                    <div className="row mt-3">
                        <div className="col-5">
                            <Label className="togglebtn_label" required data-attribute="AddFilter_Default_Label_2">Show Vehicle Capacity</Label>
                        </div>
                        <div className="col-7 p-0">
                            <SwitchToggle onChange={onToggleChange} checked={isShowVehicleCapacityChecked} className=" vehicleclasstype_togglebtn"  data-attribute="AddFilter_Default_SwitchToggle" />
                        </div>
                    </div>
                </div>
                : null}
            <ExistingList ExistingDropDownValue={ExistingDropDownValue} removeItem={removeItem} filterName={props?.filterName} catalogItemValues = {catalogItemValues} />
            <CompleteConfirmationPopup
                hideDialog={hideDialogComplete}
                onDismiss={PopupcontentComplete?.popupOutlinebtnOnclickComplete}
                Popupcontent={PopupcontentComplete}
                popupOutlinebtnOnclick={PopupcontentComplete?.popupOutlinebtnOnclickComplete}
                popupPrimarybtnOnclick={PopupcontentComplete?.popupPrimarybtnOnclick}
            />
        </div>
    )
}

export default AddFilter;

